import React from "react";
import { Box, Button, Typography, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Header from "../Layout/Header/header";
import Footer from "../Layout/Footer/footer";
import NotFoundImg from "../images/herosecImg/404 error with person looking for-rafiki 1.svg";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Header />
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: 6 }}>
        <Paper elevation={0} sx={{ p: 4, textAlign: "center", maxWidth: 500 }}>
          <img src={NotFoundImg} alt="404 Not Found" style={{ width: "100%", maxWidth: 300, marginBottom: 24 }} />
          <Typography variant="h3" sx={{ color: "#89652A", fontWeight: 700, mb: 2 }}>
          Lost in Construction?
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
          Sorry, this page doesn’t exist.<br />
          Maybe you took a wrong turn at the last brick!
          </Typography>
          <Button
   
            sx={{
                textTransform: 'capitalize', 
                fontSize: { xs: '16px', md: '16px' }, 
                fontWeight: 600, 
                borderRadius: '28px', 
                color: 'white', 
                bgcolor: '#89652A', 
                py: 0.7, 
                px: { xs: 4, md: 6 }, 
                '&:hover': { bgcolor: '#6b4e20' }, 
                '&:disabled': { bgcolor: '#a88b5e' } 
            }}
            onClick={() => navigate("/")}
          >
          Back to Home
          </Button>
        </Paper>
      </Box>
      <Footer />
    </Box>
  );
};

export default NotFound; 
